import { el, setChildren, mount, unmount } from 'redom';

import {
  getEmailContactName
} from '../utilities';

class RecipientsDisplay {

  constructor() {

    this.recipients = null;
    this.unregisterOutsideClickHandler = null;

    this.allRecipientsPanel = null;

    this.el = el('.recipients-display-main');

  }

  hideAllRecipients() {

    unmount(this.el, this.allRecipientsPanel);

  }

  async showAllRecipients() {

    this.allRecipientsPanel = el('.all-recipients-panel', this.getRenderableRecipients(this.recipients.length));

    const registerForOutsideClick = ( /* webpackIgnore: true */ await import( /* webpackIgnore: true */ 'https://cdn.venturz.co/modules/utilities/dom.js')).registerForOutsideClick;

    this.unregisterOutsideClickHandler = registerForOutsideClick(this.allRecipientsPanel, this.hideAllRecipients.bind(this));

    mount(this.el, this.allRecipientsPanel);

  }

  getRenderableRecipients(neededLength) {

    const recipients = this.recipients;
    const children = [];

    let recipientsLength = recipients.length;

    if (recipientsLength > neededLength) {
      recipientsLength = neededLength;
    }

    for (let index = 0; index < recipientsLength; index++) {

      const recipient = recipients[index];

      children.push(el('a.recipient-name.user-link', {
        href: `/contacts/${recipient._id}`
      }, getEmailContactName(recipient)));

      children.push(el('span.recipient-separator', ', '));

    }

    children.pop();

    return children;

  }

  update(recipients) {

    this.recipients = recipients;

    const defaultVisibleRecipientsCount = 2;
    const children = this.getRenderableRecipients(defaultVisibleRecipientsCount);

    if (this.recipients.length > defaultVisibleRecipientsCount) {
      children.push(el('span.other-recipients-anchor-separator', ' & '));
      children.push(el('a.other-recipients-anchor', {
        href: '#',
        onclick: this.showAllRecipients.bind(this)
      }, 'others'));
    }

    setChildren(this.el, children);

  }

}

export default RecipientsDisplay;